import Map from '../map/map';

export default new class ContactsMap {
  constructor() {
    this.sMapWrapper = 'contacts-map';
    this.obMapWrapper = $(`.${this.sMapWrapper}`);

    if (!this.obMapWrapper.length) {
      return;
    }

    this.mapSettings = {
      zoomMap: parseInt(this.obMapWrapper.attr('data-zoom'), 10),
      coordMap: [parseFloat(this.obMapWrapper.attr('data-lat')), parseFloat(this.obMapWrapper.attr('data-lng'))],
      title: this.obMapWrapper.attr('data-title'),
      text: this.obMapWrapper.attr('data-text'),
    };
    this.init();
  }

  init() {
    if (!this.obMapWrapper.length) return;

    Map.createMaps(
      'contacts-map',
      this.mapSettings.coordMap,
      this.mapSettings.zoomMap,
      this.mapSettings.title,
      this.mapSettings.text,
    );
  }
}();
